import { CoreHuawei } from './huawei';
import { GeolocationHuawei } from './geolocation';
import { DeviceHuawei } from './device';
import { PreferencesHuawei } from './preferences';
import { ShareHuawei } from './share';
import { CameraHuawei } from './camera';
export * from './definitions';
export { HuaweiBridgeClient } from './huawei-bridge-client';
export { CoreHuawei } from './huawei';
export { GeolocationHuawei } from './geolocation';
export { DeviceHuawei } from './device';
export { PreferencesHuawei } from './preferences';
export { ShareHuawei } from './share';
export { CameraHuawei } from './camera';
/**
 * Detect whether the current environment is a Huawei HarmonyOS WebView.
 * Cached after first detection to avoid repeated UA string scanning.
 *
 * Detection relies on User-Agent containing 'huawei' (case-insensitive).
 * The HarmonyOS native plugin appends "AigensSDK HuaWei" to the UA.
 */
let _isHuaWei = null;
export function isHuaWei() {
    if (_isHuaWei === null) {
        if (typeof window !== 'undefined' && window.isHuaWei === true) {
            _isHuaWei = true;
        }
        else if (typeof navigator !== 'undefined') {
            _isHuaWei = navigator.userAgent.toLowerCase().includes('huawei-aigens');
            // Cache on window for consistency with index.html detection
            if (typeof window !== 'undefined') {
                window.isHuaWei = _isHuaWei;
            }
        }
        else {
            _isHuaWei = false;
        }
    }
    return _isHuaWei;
}
/**
 * Get the Huawei Core plugin instance (singleton).
 * Use this in place of Capacitor's `Core` when `isHuaWei()` is true.
 */
let _coreHuawei = null;
export function getHuaweiCore() {
    if (!_coreHuawei) {
        _coreHuawei = new CoreHuawei();
    }
    return _coreHuawei;
}
/**
 * Get the Huawei Geolocation plugin instance (singleton).
 * Use this in place of Capacitor's `Geolocation` when `isHuaWei()` is true.
 */
let _geoHuawei = null;
export function getHuaweiGeolocation() {
    if (!_geoHuawei) {
        _geoHuawei = new GeolocationHuawei();
    }
    return _geoHuawei;
}
/**
 * Get the Huawei Device plugin instance (singleton).
 * Use this in place of Capacitor's `Device` when `isHuaWei()` is true.
 */
let _deviceHuawei = null;
export function getHuaweiDevice() {
    if (!_deviceHuawei) {
        _deviceHuawei = new DeviceHuawei();
    }
    return _deviceHuawei;
}
/**
 * Get the Huawei Preferences plugin instance (singleton).
 * Use this in place of Capacitor's `Preferences` when `isHuaWei()` is true.
 */
let _preferencesHuawei = null;
export function getHuaweiPreferences() {
    if (!_preferencesHuawei) {
        _preferencesHuawei = new PreferencesHuawei();
    }
    return _preferencesHuawei;
}
/**
 * Get the Huawei Share plugin instance (singleton).
 * Use this in place of Capacitor's `Share` when `isHuaWei()` is true.
 */
let _shareHuawei = null;
export function getHuaweiShare() {
    if (!_shareHuawei) {
        _shareHuawei = new ShareHuawei();
    }
    return _shareHuawei;
}
/**
 * Get the Huawei Camera plugin instance (singleton).
 * Use this in place of Capacitor's `Camera` when `isHuaWei()` is true.
 */
let _cameraHuawei = null;
export function getHuaweiCamera() {
    if (!_cameraHuawei) {
        _cameraHuawei = new CameraHuawei();
    }
    return _cameraHuawei;
}
//# sourceMappingURL=index.js.map